// extracted by mini-css-extract-plugin
export default {"block":"ti","select":"ui","empty":"vi","open":"wi","error":"xi","options":"yi","selectActive":"zi","ornament":"Ai"};